module.exports = __webpack_public_path__ + "img/ic-walk.37eee5e9.svg";